import React, { useState } from 'react'
import { Scrollbars } from 'react-custom-scrollbars'

import { AvisoImpersonate } from '../barra-superior-layout/styles'
import { AutenticacaoContainer, Botao } from '../'
import { Logo } from '../imagens'
import {
  Centralizado,
  Container,
  Conteudo,
  Layout as ComponenteLayout,
  BarraSuperior,
  BarraLateral
} from './styles'

export const LayoutMatricula: React.FC = ({ children }) => {
  const {
    usuario,
    sair,
    impersonando,
    encerrarImpersonate
  } = AutenticacaoContainer.useContainer()
  const [saindoDoImpersonate, definirSaindoDoImpersonate] = useState(false)

  return (
    <ComponenteLayout>
      <BarraLateral />
      <BarraSuperior>
        {Logo()}
        {impersonando && (
          <AvisoImpersonate>
            <span>
              Impersonando: <strong>{usuario?.nomeApresentacao}</strong>
            </span>
            <button
              type="button"
              id="btn_sair_impersonate"
              disabled={saindoDoImpersonate}
              onClick={async () => {
                definirSaindoDoImpersonate(true)
                try {
                  await encerrarImpersonate()
                } finally {
                  definirSaindoDoImpersonate(false)
                }
              }}
            >
              {saindoDoImpersonate ? 'Saindo...' : 'Sair do impersonate'}
            </button>
          </AvisoImpersonate>
        )}
        {!!usuario && (
          <Botao
            onClick={() => {
              sair(true)
              window.location.reload()
            }}
            texto="Sair"
            tema="Link"
          />
        )}
      </BarraSuperior>
      <Container>
        <Scrollbars style={{ height: 'calc(100vh - 72px)' }}>
          <Conteudo>
            <Centralizado>{children}</Centralizado>
          </Conteudo>
        </Scrollbars>
      </Container>
    </ComponenteLayout>
  )
}
